import { Promise } from 'bluebird';
import AnchorAPIError from './AnchorAPIError';

const urlPath = `/api/proxy/v3/settings/podcast-category/options`;

interface PodcastCategory {
  value: string;
  display: string;
  subCategories: PodcastCategory[];
}

const fetchPodcastCategories = () =>
  new Promise<PodcastCategory[]>((resolve, reject) =>
    fetch(urlPath, {
      method: 'GET',
      credentials: 'same-origin',
    })
      .then((value: any) => resolve(value))
      .catch(reject)
  )
    .then(
      (response: any): void => {
        if (response.status === 200) {
          return response.json();
        }
        throw new AnchorAPIError(
          response,
          `Non 200 response status: ${response.status}`
        );
      }
    )
    .catch(err => {
      throw new AnchorAPIError(err);
    });

export { fetchPodcastCategories };
